import React from 'react';
import { Gps } from '../../pages/arc/models/arc-epi-props';
import { GuidedProcessSupport } from './guided-process-support';
import { ContentSpacer } from './layout/generic-content-spacer';


export interface Props {
	title: string;
	contents: Gps[];
}

export const GuidedProcessSupportBlock = (props: Props) => {

	return (
		props.contents?.length > 0 &&
		<div className='sidebar'>
			<ContentSpacer>
				<h2>{props.title}</h2>
			</ContentSpacer >
			{props.contents?.map((a, idx) => { return <GuidedProcessSupport key={idx} content={a} />; })}
		</div>
	);
}; 